<template>
  <v-img max-height="150" contain :src="banner" alt="Valenz" position="right" />
</template>

<script>
// @ is an alias to /src
import banner from "@/assets/images/logos/Valenz_Assurance.png";
export default {
  name: "ValenzFooterView",
  data() {
    return {
      banner: banner,
    };
  },
};
</script>
